import React from 'react';

import s from './emptyCartDySkeleton.scss';

/**
 * Empty Cart bottom part skeleton
 */
export const EmptyCartDySkeleton = () => (
    <div className={s.container}>
        <div className={s.item} />
        <div className={s.item} />
        <div className={s.item} />
    </div>
);
